import React, { useState, useEffect } from 'react';
import { Jumbotron, Container, FormGroup, FormLabel, FormControl, Button } from 'react-bootstrap';
//import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import { LinkContainer } from 'react-router-bootstrap'; // Ensure this import is added

const LifeClock = ({ isLoading, incorrectPasswordUser, sessionIsLoading, users, userLifeExpectancy, userBirthDate, editUser, loggedInUser }) => {
  
  console.log('users', users)
  console.log('userLoggedInID', loggedInUser._id);
  console.log('userLifeExpectancy in viewdocumentlist *******', Number(userLifeExpectancy));
  console.log('userBirthDate in viewdocumentlist *******', userBirthDate);

  const [lifeExpectancy, setLifeExpectancy] = useState(null); // Start as null
  const [birthDate, setBirthDate] = useState(null); // Start as null

  console.log('State lifeExpectancy in viewdocumentlist *******', lifeExpectancy);
  console.log('State birthdate in viewdocumentlist *******', birthDate);

useEffect(() => {
    if (userLifeExpectancy !== undefined && userLifeExpectancy !== null) {
        setLifeExpectancy(Number(userLifeExpectancy)); // Convert only when data exists
        
    }
    if (userBirthDate !== undefined && userBirthDate !== null) {
        const updatedUserBirthDate = userBirthDate.split("T")[0];
        setBirthDate(updatedUserBirthDate);
        //console.log('State birthdate in viewdocumentlist *******', birthDate);
    }
}, [userLifeExpectancy, userBirthDate]); // Runs when lifeClockData updates
  
  const [weeks, setWeeks] = useState([]);
  const [weeksLived, setWeeksLived] = useState(0);
  const [yearsWith53Weeks, setYearsWith53Weeks] = useState(0);

  const weeksPerYear = 52;

  const calculateWeeks = () => {
    const today = new Date();
    const birthdayDate = new Date(birthDate);
    const totalWeeks = lifeExpectancy * weeksPerYear;
    const livedWeeks = Math.floor((today - birthdayDate) / (1000 * 60 * 60 * 24 * 7));

    const calculateYearsWith53Weeks = () => {
      let count = 0;
      for (let year = birthdayDate.getFullYear(); year <= today.getFullYear(); year++) {
        const jan1 = new Date(year, 0, 1);
        const daysInYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 366 : 365;
        if ((daysInYear === 365 && jan1.getDay() === 4) || (daysInYear === 366 && (jan1.getDay() === 3 || jan1.getDay() === 4))) {
          count++;
        }
      }
      return count;
    };

    const yearsWithExtraWeeks = calculateYearsWith53Weeks();

    const weeksArray = Array.from({ length: totalWeeks }, (_, index) => ({
      weekNumber: index + 1,
      //weekNumber: index,
      isPast: index < livedWeeks - yearsWithExtraWeeks,
      isCurrent: index === livedWeeks - yearsWithExtraWeeks,
    }));

    setWeeks(weeksArray);
    setWeeksLived(livedWeeks);
    setYearsWith53Weeks(yearsWithExtraWeeks);
  };

  useEffect(() => {
    calculateWeeks();
  }, [lifeExpectancy, birthDate]);

  if (isLoading && incorrectPasswordUser) {
    return (
      <div className="viewPage">
        <Jumbotron>
          <h1>You entered an incorrect username or password</h1>
        </Jumbotron>
        <LinkContainer to="/login">
          <Button bsstyle="primary">Try Again</Button>
        </LinkContainer>
      </div>
    );
  } else if (isLoading || sessionIsLoading) {
    return (
      <div className="viewPage">
        <Jumbotron>
          <h1>MyLifeClock is Loading</h1>
        </Jumbotron>
      </div>
    );
  }

  return (
    <div className="viewPage Hero-banner">
      <Jumbotron>
        <h1>{loggedInUser.userFirstName} {loggedInUser.userLastName} </h1>
      </Jumbotron>

      <Container>
        <FormGroup>
          <FormLabel>Life Expectancy (years):</FormLabel>
          <FormControl
            type="number"
            value={lifeExpectancy}
            min="1"
            onChange={(e) => setLifeExpectancy(Number(e.target.value))}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Date of Birth:</FormLabel>
          <FormControl
            type="date"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
          />
        </FormGroup>
        <Button onClick={() => editUser(loggedInUser, undefined, undefined, undefined, undefined, undefined, lifeExpectancy, birthDate)} bsstyle="success" variant="primary">Save</Button>
        <br />
        <br />

        <p>You have lived <strong>{weeksLived}</strong> weeks so far.</p>
        <p>You have lived <strong>{(weeksLived / 52).toFixed(2)}</strong> years so far.</p>
        <p>Years with 53 weeks: <strong>{yearsWith53Weeks}</strong></p>
      </Container>

      <div className="grid-container"> 
        <div className="grid">
          
          {Array.from({ length: lifeExpectancy }).map((_, yearIndex) => (
            <div className="column" key={yearIndex}>
              {weeks
                .slice(yearIndex * weeksPerYear, (yearIndex + 1) * weeksPerYear)
                .map((week, weekIndex) => (
                  <div
                    key={weekIndex}
                    className={`box ${week.isPast ? 'past' : ''} ${
                      week.isCurrent ? 'current' : ''
                    }`}
                    title={`Year ${yearIndex + 1}, Week ${week.weekNumber}`}
                  />
                ))}
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .grid-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          width: 100vw;
        }

        .grid {
          display: flex;
          flex-direction: row;
        }

        .column {
          display: flex;
          flex-direction: column;
          margin-right: 3px;
        }

        .box {
          width: 9px;
          height: 9px;
          margin: 1.8px;
          background-color: lightgray;
          border: 1.2px solid #ddd;
          border-radius: 2.4px;
          transition: all 0.2s ease-in-out;
        }

        .box.past {
          background-color: #4a4a4a;
          border: 1.2px solid #a0a0a0;
        }

        .box.current {
          animation: pulseWithBorderColor 8s infinite;
          width: 9.6px;
          height: 9.6px;
          background-color: red;
          border: 2px solid red;
        }

        @keyframes pulseWithBorderColor {
          0% {
            transform: scale(1);
            border-color: red;
          }
          50% {
            transform: scale(1.5);
            border-color: #ff7f7f;
          }
          100% {
            transform: scale(1);
            border-color: red;
          }
        }
      `}</style>
    </div>
  );
};

export default LifeClock;